import { attribute, attributeGetter, Component } from "@bodil/dom/component";
import type { Role } from "aria-attribute-types";
import { html } from "lit";
import { customElement } from "lit/decorators.js";

import styles from "./divider.css?inline";

declare global {
    interface HTMLElementTagNameMap {
        "btk-divider": BtkDivider;
    }
}

@customElement("btk-divider")
export class BtkDivider extends Component {
    @attribute({ type: Boolean }) accessor vertical = false;

    @attributeGetter get role(): Role {
        return "separator";
    }

    @attributeGetter({ reactive: true, reflect: true }) get ariaOrientation():
        | "vertical"
        | "horizontal"
        | null {
        return this.vertical ? "vertical" : "horizontal";
    }

    protected override render(): unknown {
        return html`<slot></slot>`;
    }

    static styles = styles;
}
